module.exports = __webpack_public_path__ + "images/emoji/tea.ba01fce69d92c07af940.png";